let Balboa = require("ES/services/Balboa");
let RadioService = require("ES/lib/react-pubsub-via-radio.js/service");

module.exports.init = function(){

	RadioService("Authenticate_signin", function(data, callback){
		Balboa.api("/oauth2/signinpassword", {
			username: data.username,
			password: data.password
		}, function(data){
			callback();
		}, function(data){
			callback((data && data.message) || "unknown cause");
		});
	});

	RadioService("Authenticate_forgotpassword", function(username, callback){
		Balboa.api("/authenticate/forgotpassword", {
			username: username
		}, function(data){
			callback(null, "Check your email inbox. An email has just been sent to you with a password reset link that expires in 90 minutes.");
		}, function(data){
			callback("Unable to send forgot password email: " + ((data && data.message) || " Check your internet connection."));
		});
	});

};



// WEBPACK FOOTER //
// ./src/services/Authenticate.js